import { useRef } from 'react';
export default (isScrollAtTop, isScrollAtBottom) => {
    // Do lock for a wheel when scrolling
    const lockRef = useRef(false);
    const lockTimeoutRef = useRef(null);
    function lockScroll() {
        clearTimeout(lockTimeoutRef.current);
        lockRef.current = true;
        lockTimeoutRef.current = setTimeout(() => {
            lockRef.current = false;
        }, 50);
    }
    // Pass to ref since global add is in closure
    const scrollPingRef = useRef({
        top: isScrollAtTop,
        bottom: isScrollAtBottom
    });
    scrollPingRef.current.top = isScrollAtTop;
    scrollPingRef.current.bottom = isScrollAtBottom;
    return (deltaY, smoothOffset = false) => {
        const originScroll = 
        // Pass origin wheel when on the top
        (deltaY < 0 && scrollPingRef.current.top) ||
            // Pass origin wheel when on the bottom
            (deltaY > 0 && scrollPingRef.current.bottom);
        if (smoothOffset && originScroll) {
            // No need lock anymore when it's smooth offset from touchMove interval
            clearTimeout(lockTimeoutRef.current);
            lockRef.current = false;
        }
        else if (!originScroll || lockRef.current) {
            lockScroll();
        }
        return !lockRef.current && originScroll;
    };
};
